import GetAppIcon from "@mui/icons-material/GetApp";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  SpeedDialAction,
  Switch,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import CustomSpeedDialog from "../../components/CustomSpeedDialog";
import Comanda from "../../imagens/iconeComanda.svg";
import DeliveryIcon from "../../imagens/iconeDelivery";
import Mesa from "../../imagens/iconeMesa.svg";
import Sequencial from "../../imagens/iconeSequencial";
import Util from "../../utils";
import TemplateBase from "../Generico/TemplateBase";

import { useSnackbar } from "notistack";
import ConfigQr from "./components/compConfigQr";
import FormDialogAlterarTipo from "./components/FormDialogAlterarTipo";
import FormDialogGerarMesas from "./components/FormDialogGerarMesas";
import MenuDetalhe from "./components/MenuDetalhe";

const Identificadores = () => {
  const [identificadores, setIdentificadores] = useState([]);
  const [openDialogGerarMesas, setOpenDialogGerarMesas] = useState(false);
  const [filtrarPor, setFiltrarPor] = useState("TODOS");
  const [ativo, setAtivo] = useState(true);
  const [buscando, setBuscando] = useState(false);
  const [open, setOpen] = useState(false);
  const [identificadorEdicao, setIdentificadorEdicao] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [count, setCount] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    document.title = "QR Pedir - Identificadores";
    handleFiltrarPor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ativo, page, rowsPerPage, filtrarPor]);

  const handleOpenDialogGerarMesas = () => setOpenDialogGerarMesas(true);
  const handleCloseDialogGerarMesas = () => setOpenDialogGerarMesas(false);
  const handleToggle = () => setOpen((prev) => !prev);

  const handleChangeSwitch = (e) => {
    setAtivo(e.target.checked);
  };

  const handleChangePage = (__, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeTipo = (event) => {
    setFiltrarPor(event.target.value);
    setPage(0);
  };

  const handleFiltrarPor = () => {
    const service = new AuthService();
    let filtro = filtrarPor !== "TODOS" ? `findBy=tipo:${filtrarPor}&` : "";

    setBuscando(true);
    service
      .request(
        `/identificador/list?${filtro}first=${
          rowsPerPage * page
        }&max=${rowsPerPage}&ativo=${ativo}`
      )
      .then((response) => {
        const totalCount = response.headers.get("totalCount");
        setCount(parseInt(totalCount));
        return response.json();
      })
      .then((retorno) => {
        setIdentificadores(retorno);
        setBuscando(false);
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Falha ao buscar mesas", { variant: "error" });
        setBuscando(false);
      });
  };

  const inativarIdentificador = (identificador) => {
    const service = new AuthService();
    service
      .delete(`/identificador/${identificador.id}`)
      .then((retorno) => {
        identificador.ativo = retorno.ativo;
        setIdentificadores([...identificadores]);
        enqueueSnackbar(
          `${retorno.tipo} ${retorno.numero} inativado com sucesso`,
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Falha ao inativar identificador", {
          variant: "error",
        });
      });
  };

  const ativarIdentificador = (identificador) => {
    const service = new AuthService();
    identificador.ativo = true;
    service
      .put(`/identificador`, identificador)
      .then((retorno) => {
        identificador.ativo = retorno.ativo;
        setIdentificadores([...identificadores]);
        enqueueSnackbar(
          `${retorno.tipo} ${retorno.numero} ativado com sucesso`,
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Falha ao inativar identificador", {
          variant: "error",
        });
      });
  };

  const alterarIdentificador = (identificador, onSuccess) => {
    const service = new AuthService();
    service
      .put(`/identificador`, identificador)
      .then((resp) => {
        identificador.tipo = resp.tipo;
        setIdentificadores([...identificadores]);
        enqueueSnackbar("Identificador alterado com sucesso.", {
          variant: "success",
        });
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        if (!err.response) {
          enqueueSnackbar("Falha ao alterar identificador.", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              `Falha ao alterar identificador. Erro: ${elem.errorMessage}`,
              {
                variant: "error",
              }
            );
          });
        }
      });
  };

  return (
    <TemplateBase
      title="Mesas e QRCodes"
      subTitle="Aqui você pode ver suas mesas, gerar novas ou inativá-las"
    >
      <ConfigQr open={open} handleToggle={handleToggle} />
      <Box p={4}>
        <Grid container spacing={1} alignItems="center">
          <Grid
            size={{
              sm: 12,
            }}
          >
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="tipo"
                value={filtrarPor}
                onChange={handleChangeTipo}
              >
                {["TODOS", "MESA", "COMANDA", "SEQUENCIAL", "DELIVERY"].map(
                  (tipo) => (
                    <FormControlLabel
                      key={tipo}
                      value={tipo}
                      control={<Radio />}
                      label={tipo.charAt(0) + tipo.slice(1).toLowerCase()}
                    />
                  )
                )}
              </RadioGroup>
            </FormControl>
            <FormControlLabel
              control={<Switch checked={ativo} onChange={handleChangeSwitch} />}
              label={ativo ? "Ativos" : "Inativos"}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <CustomSpeedDialog>
        <SpeedDialAction
          icon={<PlayArrowIcon />}
          tooltipTitle="Gerar"
          tooltipOpen
          onClick={handleOpenDialogGerarMesas}
        />
        <SpeedDialAction
          icon={<GetAppIcon />}
          tooltipTitle="Baixar"
          tooltipOpen
          onClick={handleToggle}
        />
      </CustomSpeedDialog>
      <Grid container justifyContent="flex-end">
        <FormDialogGerarMesas
          handleRefresh={handleFiltrarPor}
          isOpen={openDialogGerarMesas}
          open={handleOpenDialogGerarMesas}
          close={handleCloseDialogGerarMesas}
        />
      </Grid>

      <Box p={4}>
        <Grid container spacing={2}>
          {buscando
            ? Array.from({ length: rowsPerPage }).map((_, index) => (
                <Grid
                  key={index}
                  size={{
                    xs: 6,
                    sm: 4,
                    md: 3,
                    lg: 2,
                  }}
                >
                  <Skeleton variant="rectangular" height={160} />
                </Grid>
              ))
            : identificadores.map((identificador) => (
                <Grid
                  key={identificador.id}
                  size={{
                    xs: 6,
                    sm: 4,
                    md: 3,
                    lg: 2,
                  }}
                >
                  <Paper style={{ opacity: identificador.ativo ? "1" : "0.3" }}>
                    <Box p={2} textAlign="center" minHeight={160}>
                      <Typography
                        color="textSecondary"
                        style={{
                          fontFamily: "Bebas Neue",
                          fontWeight: 600,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {identificador.tipo === "MESA" && (
                          <img alt="MESA" src={Mesa} width={32} />
                        )}
                        {identificador.tipo === "COMANDA" && (
                          <img alt="COMANDA" src={Comanda} width={32} />
                        )}
                        {identificador.tipo === "SEQUENCIAL" && (
                          <Sequencial style={{ width: 32 }} />
                        )}
                        {identificador.tipo === "DELIVERY" && (
                          <DeliveryIcon style={{ width: 32 }} />
                        )}
                        <br />
                        {Util.labelTipoIdentificador(identificador.tipo)}
                      </Typography>
                      <Typography variant="h4" title={identificador.uuid}>
                        {identificador.numero}
                      </Typography>
                      <MenuDetalhe
                        itens={[
                          {
                            nome: "Inativar",
                            call: () => inativarIdentificador(identificador),
                            visible: identificador.ativo,
                          },
                          {
                            nome: "Ativar",
                            call: () => ativarIdentificador(identificador),
                            visible: !identificador.ativo,
                          },
                          {
                            nome: "Editar identificador",
                            call: () => setIdentificadorEdicao(identificador),
                            visible: identificador.ativo,
                          },
                        ]}
                      />
                    </Box>
                  </Paper>
                </Grid>
              ))}
        </Grid>

        <Box mt={4}>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Linhas por página"
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
      <FormDialogAlterarTipo
        identificador={identificadorEdicao}
        handleClose={() => setIdentificadorEdicao(null)}
        alterarIdentificador={alterarIdentificador}
      />
    </TemplateBase>
  );
};

export default Identificadores;
